/* global tripApi */
import {
  TripApi, TripMutation, TripsPage, Trip, TripsSummary, TripError, GetTrip, TripIdPair, // eslint-disable-line no-unused-vars
} from '@clients/myTrips'
import { toEndOfDayIsoString, toStartOfDayIsoString } from '@util/dates-and-times'
import { AxiosPromise } from 'axios' // eslint-disable-line no-unused-vars
import appendCredentials from '@util/appendCredentials'
import getBasePath from '@util/path'

let basePath = getBasePath() + '/my-trips'

export default class ExtendedTripApi {
  tripApi: TripApi = new TripApi();

  constructor (params: any) {
    this.tripApi = new TripApi(params)
  }

  getTrips (vehicleId?: number, filterFrom?: string | Date, filterUntil?: string | Date, filterTagIds?: string, filterPilotIds?: string, filterZoneIds?: string, filterFsl?:boolean, filterWork?:boolean, sort?: 'startTimestamp' | 'endTimestamp', order?: 'asc' | 'desc', pageOffset?: number, pageLimit?: number, options?: any): AxiosPromise<TripsPage> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return this.tripApi.getTripsSkipVehicleId(undefined, vehicleId, toStartOfDayIsoString(filterFrom), toEndOfDayIsoString(filterUntil), filterTagIds, filterPilotIds, filterZoneIds, filterFsl, filterWork, sort, order, pageOffset, pageLimit, optionsParam)
  }

  createTrip (tripCreateRequestBody: TripMutation, options?: any): AxiosPromise<Trip> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return this.tripApi.createTripSkipVehicleId(tripCreateRequestBody, undefined, optionsParam)
  }

  mergeTrip (vehicleId: number, tripIdPair: TripIdPair, options?: any): AxiosPromise<Trip> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return this.tripApi.createTripMerge(vehicleId, tripIdPair, undefined, optionsParam)
  }

  getTripSummarized (vehicleId?: number, filterFrom?: string | Date, filterUntil?: string | Date, filterTagIds?: string, filterPilotIds?: string, filterZoneIds?: string, options?: any): AxiosPromise<TripsSummary> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return this.tripApi.getTripSummarizedSkipVehicleId(undefined, vehicleId, toStartOfDayIsoString(filterFrom), toEndOfDayIsoString(filterUntil), filterTagIds, filterPilotIds, filterZoneIds, optionsParam)
  }

  getTrip (id: number, include: Array<any>, options?: any): AxiosPromise<GetTrip> {
    const optionsParam = appendCredentials(options)
    return this.tripApi.getTripSkipVehicleId(id, undefined, include, optionsParam)
  }

  updateTrip (id: number, tripUpdateRequestBody: TripMutation, validateConflict: boolean = true, options?: any): AxiosPromise<Trip> {
    const optionsParam = appendCredentials(options)
    return this.tripApi.updateTripSkipVehicleId(id, tripUpdateRequestBody, undefined, validateConflict, optionsParam)
  }

  deleteTrip (id: number, options?: any): AxiosPromise<void> {
    const optionsParam = appendCredentials(options)
    return this.tripApi.deleteTripSkipVehicleId(id, undefined, optionsParam)
  }

  getTripErrors (vehicleId: number, filterFrom?: Date, filterUntil?: Date, options?: any): AxiosPromise<Array<TripError>> {
    const optionsParam = appendCredentials(options)
    return this.tripApi.getTripErrors(vehicleId, undefined, toStartOfDayIsoString(filterFrom), toEndOfDayIsoString(filterUntil), optionsParam)
  }
}
